import { render, staticRenderFns } from "./DocumentsCommonList.vue?vue&type=template&id=d5b24d2a&scoped=true&"
import script from "./DocumentsCommonList.vue?vue&type=script&lang=js&"
export * from "./DocumentsCommonList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsCommonList.vue?vue&type=style&index=0&id=d5b24d2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b24d2a",
  null
  
)

export default component.exports